import { LOGIN_ROUTE } from './../modules/accounts/constants/routes.constants';
import { PUBLIC_ROUTE } from './routes.constants';
export const MESSAGES = {
  ERROR: {
    $401: 'Your session is expired, Please Login again.',
    $404: 'Resource not found',
    $500: 'Internal Server Error',
    $504: 'Slow Internet Connection',
    $0: 'Something went wrong, Please try again.',
    UNKNOWN: 'Something went wrong at our end'
  },
  NAVIGATION: {
    NOT_FOUND: 'Navigation Error occurred'
  },
  OFFLINE: 'You are offline, Please connect to Internet and Retry'
};

export const ERROR_MESSAGES = {

};
export const APPROVE = {
  confirm: (type, count = 1) => `Do you want to approve ${count == 1 ? 'this' : 'these'} ${type.toLowerCase()}?`,
  success: (type, count = 1) => `${type} ${count == 1 ? 'has' : 'have'} been Approved successfully`
};

export const DELETED = {
  confirm: (type, count = 1) => `Do you want to delete ${count == 1 ? 'this' : 'these'} ${type.toLowerCase()}?`,
  success: (type, count = 1) => `${type} ${count == 1 ? 'has' : 'have'} been deleted successfully`
};

export const UNBLOCKED = {
  confirm: (type, count = 1) => `Do you want to unblock ${count == 1 ? 'this' : 'these'} ${type.toLowerCase()}?`,
  success: (type, count = 1) => `${type} ${count == 1 ? 'has' : 'have'} been unblocked successfully`
};

export const BLOCKED = {
  confirm: (type, count = 1) => `Do you want to block ${count == 1 ? 'this' : 'these'} ${type.toLowerCase()}?`,
  success: (type, count = 1) => `${type} ${count == 1 ? 'has' : 'have'} been blocked successfully`
};

export const INACTIVE = {
  confirm: (type, count = 1) => `Do you want to block ${count == 1 ? 'this' : 'these'} ${type.toLowerCase()}?`,
  success: (type, count = 1) => `${type} ${count == 1 ? 'has' : 'have'} been blocked successfully`
};

export const ACTIVE = {
  confirm: (type, count = 1) => `Do you want to unblock ${count == 1 ? 'this' : 'these'} ${type.toLowerCase()}?`,
  success: (type, count = 1) => `${type} ${count == 1 ? 'has' : 'have'} been unblocked successfully`
};


export const PUBLISHED = {
  confirm: (type, count = 1) => `Do you want to publish ${count == 1 ? 'this' : 'these'} ${type.toLowerCase()}?`,
  success: (type, count = 1) => `${type} ${count == 1 ? 'has' : 'have'} been published successfully`
};

export const INVITE = {
  confirm: (type, count = 1) => `Do you want to invite ${count == 1 ? 'this' : 'these'} ${type.toLowerCase()}?`,
  success: (type, count = 1) => `${type} ${count == 1 ? 'has' : 'have'} been invited successfully`
};

export const ADDED = (type) => `${type} added successfully`;

export const UPDATED = (type) => `${type} updated successfully`;

export const DELETED__BY_ADMIN = (type: string) => `This ${type} has been Deleted By Admin`


export const DELETE_SUCCESS = (type) => `${type} delete successfully`;
export const MODIFIED = (type) => `${type} modified successfully`;

export const REQUIRED = (type: string) => `${type} is Required`;
export const SELECT = (type: string) => `Please select a ${type}`;

export const CONFIRMATION_QUESTION = (title: string, message: string) => `Are you sure ${message}?`;

export const INVALID_IMAGE_ERROR = (format = 'jpeg/png') => `Only ${format} images are allowed`;

export const INVALID_VIDEO_ERROR = (format = 'mp4/webm/ogg') => `Only ${format} videos are allowed`;

export const INVALID_AUDIO_ERROR = (format = 'mp3/wav/mpeg') => `Only ${format} audios are allowed`;

export const INVALID_FILE_ERROR = (size = 4) => `File size can not be more than ${size} MB`;


export const MESSAGES_CONSTANTS = {
  SIGNUP_SUCCESS: {
    title: 'Signup Successful',
    message: 'Your Account has been created. Please verify your email to proceed further',
    redirectUrl: LOGIN_ROUTE.url,
    showCloseBtn: true
  },
  FORGOT_PASSWORD: {
    title: 'Check your Inbox',
    message: 'We have sent you an email with a link to reset your password. Please check your Spam/Junk folder',
    showCloseBtn: true
  },
  RESET_PASSWORD: {
    title: 'Congratulations!',
    message: 'Your password has been changed successfully',
    redirectUrl: PUBLIC_ROUTE.url,
    showCloseBtn:true
  }

}

export const TOPIC_MESSAGES_CONSTANTS = {

  HIDE_CONFIRMATION: {
    title: 'Hide this Topic',
    message: 'Are you sure you want to hide this topic?'
  },
  DELETE_CONFIRMATION: {
    title: 'Delete this Topic!',
    message: `Are you sure you want to delete this topic? `,
  },

  REPORT_TOPIC_CONFIRMATION: {
    title: 'Report this Topic!',
    message: 'Are you sure you want to report this topic?',
  },

}


export const POST_CONFIRMATION = {
  DELETE_CONFIRMATION: {
    title: 'Delete this post',
    message: 'Are you sure you want to delete this post?'
  },
  REPORT_CONFIRMATION: {
    title: 'Report this post',
    message: 'Are you sure you want to report this post?'
  },
  HIDE_CONFIRMATION: {
    title: 'Hide this post',
    message: 'Are you sure you want to hide this post?'
  },
  UNHIDE_CONFIRMATION: {
    title: 'Unhide this post',
    message: 'Are you sure you want to unhide this post?'
  }
}


export const POST_COMMENT_CONFIRMATION = {
  DELETE_CONFIRMATION: {
    title: 'Delete this comment',
    message: 'Are you sure you want to delete this comment?'
  },
  REPORT_CONFIRMATION: {
    title: 'Report this comment',
    message: 'Are you sure you want to report this comment?'
  },
  HIDE_CONFIRMATION: {
    title: 'Hide this comment',
    message: 'Are you sure you want to hide this comment?'
  },
  UNHIDE_CONFIRMATION: {
    title: 'Unhide this comment',
    message: 'Are you sure you want to unhide this comment?'
  }
}


export const NOTIFICATION_CONFIRMATIONS = {
  CLEAR_ALL_NOTIFICATION: {
    title: 'Clear all notification',
    message: 'Are you sure you want to clear all notifications?'
  },
}

export const POST_COMMENT_REPLY_CONFIRMATION = {
  DELETE_CONFIRMATION: {
    title: 'Delete this reply',
    message: 'Are you sure you want to delete this reply?'
  },
  REPORT_CONFIRMATION: {
    title: 'Report this reply',
    message: 'Are you sure you want to report this reply?'
  },
  HIDE_CONFIRMATION: {
    title: 'Hide this reply',
    message: 'Are you sure you want to hide this reply?'
  },
  UNHIDE_CONFIRMATION: {
    title: 'Unhide this reply',
    message: 'Are you sure you want to unhide this reply?'
  }
}

const reportList = [
  { title: 'Offensive Language', value: 'offensive language' },
  { title: 'Spam', value: 'spam' },
  { title: 'Inappropriate content', value: 'Inappropriate content' },
  { title: 'Hate speech', value: 'Hate speech' },
  { title: 'Harassment', value: 'harassment' },
  { title: 'Others', value: 'others' },
]

const businessReportReasons = [
  { title: 'Business Closed', value: 'Business Closed' },
  { title: 'Business Name Changed', value: 'Business Name Changed' },
  { title: 'Address or Phone Number Inaccurate', value: 'Address or Phone Number Inaccurate' },
  { title: 'Web Link Not Working', value: 'Web Link Not Working' },
  { title: 'Other', value: 'others' },
]


export const REPORT_REASONS = {
  POST_REPORT_REASONS: {
    title: 'Report a post',
    reasons: reportList,
    cancelText: 'Cancel',
    confirmText: 'Confirm '
  },
  POST_COMMENT_REPORT_REASONS: {
    title: 'Report a comment',
    reasons: reportList,
    cancelText: 'Cancel',
    confirmText: 'Confirm '
  },
  POST_COMMENT_REPLY_REPORT_REASONS: {
    title: 'Report a reply',
    reasons: reportList,
    cancelText: 'Cancel',
    confirmText: 'Confirm '
  },
  TOPIC_REPORT_REASONS: {
    title: 'Report a topic',
    reasons: reportList,
    cancelText: 'Cancel',
    confirmText: 'Confirm '
  },
  TOPIC_ANSWER_REPORT_REASONS: {
    title: 'Report a answer',
    reasons: reportList,
    cancelText: 'Cancel',
    confirmText: 'Confirm '
  },
  TOPIC_ANSWER_REPLY_REPORT_REASONS: {
    title: 'Report a reply',
    reasons: reportList,
    cancelText: 'Cancel',
    confirmText: 'Confirm '
  },
  BUSINESS_REPORT_REASONS: {
    title: 'Report this business',
    reasons: businessReportReasons,
    cancelText: 'Cancel',
    confirmText: 'Submit'
  }


}






export const TOPIC_ANSWERS_CONSTANTS = {
  HIDE_CONFIRMATION: {
    title: 'Hide this Answer',
    message: 'Are you sure you want to hide this answer?'
  },
  DELETE_CONFIRMATION: {
    title: 'Delete this Answer!',
    message: 'Are you sure you want to delete this answer?',
  },

  REPORT_TOPIC_ANSWER_CONFIRMATION: {
    title: 'Report this Answer!',
    message: 'Are you sure you want to report this answer?',
  },

  UNHIDE_CONFIRMATION: {
    title: 'Unhide this Answer',
    message: 'Are you sure you want to unhide this answer?'
  }

}


export const TOPIC_ANSWERS_REPLY_CONSTANTS = {
  HIDE_CONFIRMATION: {
    title: 'Hide this Reply',
    message: 'Are you sure you want to hide this reply?'
  },
  UNHIDE_CONFIRMATION: {
    title: 'Unhide this Reply',
    message: 'Are you sure you want to Unhide this reply?'
  },
  DELETE_CONFIRMATION: {
    title: 'Delete this Reply!',
    message: 'Are you sure you want to delete this reply?',
  },

  REPORT_TOPIC_ANSWER_REPLY_CONFIRMATION: {
    title: 'Report this Reply!',
    message: 'Are you sure you want to report this reply?',
  },
}
export const UNSAVED_CHANGES_CONSTANTS = {
  UNSAVE: {
    title: 'Confirmation',
    message: 'Are you sure?'
  }
}

export const FOLLOW_UNFOLLOW_CONFIRM_CONSTANTS = {
  UNFOLLOW: {
    title: 'Unfollow this user',
    message: 'Are you sure you want to unfollow this user?'
  },
  FOLLOW: {
    title: 'Follow this user',
    message: 'Are you sure you want to follow this user?'
  }
}


export const LOCATION_ACCESS_CONSTANTS = {
  ALLOW: {
    title: 'Location Allowance Request',
    message: ` Please enable location services, so we can recommend nearby users, events, and businesses.
  <br> Allow location then press confirm`,
    hideCancelButton: true,
    disableClose: true
  }
}


export const EVENTS_CONSTANTS = {
  DELETE: {
    title: 'Delete this event',
    message: 'Are you sure you want to delete this event?'
  },
}



export const PROFILE_RELATED_CONFIRMATION = {

  LOGOUT: {
    title: 'Logout Confirmation',
    message: 'Are you sure you want to logout?'
  },
}

export const BUSINESS_REVIEWS_CONFIRMATIONS = {
  DELETE: {
    title: 'Delete Confirmation',
    message: 'Are you sure you want to delete this review'
  }
}

export const BUSINESS_FOLLOW_UNFOLLOW_CONFIRMATION = {
  UNFOLLOW: {
    title: 'Unfollow Confirmation',
    message: 'Are you sure you want to Unfollow this business'
  }
}

export const AGREE_TERM_CONDITION = 'Please accept the Terms & Conditions and Privacy Policy to proceed';





export const TOPIC_FORM_MESSAGES_CONSTANTS = {

  TAGS_REQUIRED: 'Tag is mandatory, Please select one'

}


export const FOLLOWED = 'User has been followed successfully';
export const UNFOLLOWED = 'User has been Unfollowed successfully';

export const UPLOADIMAGE = 'Please select atleast one image';

export const PROFILE_UPDATED = 'Profile Updated Successfully';


export const PASSWORD_ERROR_MESSAGE = "Password must contain at least 1 uppercase, 1 lowercase, 1 number, 1 special character, minimum 6 and maximum 24 characters";

export const OLD_NEW_PASS_MSG = "New password should be different from the new one.";

export const DISABLE_EDIT = (custom: string) => `This ${custom} is not editable`;

export const BLOCKED_BY_ADMIN = 'Your account has been blocked by the admin';
